/*
Author: Shivakumar
Date: 05/03/2020
Issue Description: [Resignation Date] There is no validation with respect to Date of Joining of an employee.
search_string: PL_1673
*/

<template>
  <div>
    <div class="paygrpsDiv">
      <div class="paygrp">
        <span>
          <b>Exits</b>
        </span>
        <div class="paygrps-info">
          <b>{{ exitsCount }}</b>
          / {{countObj.totalEmployees}}
          <!-- {{countObj.totalResignees}} -->
        </div>
      </div>
      <div class="alignPaygrp">
        <span>Paygroups Selected</span>
        <br />
        <div class="paygrps-info">
          <b>{{countObj.payGroupsSelected}}</b>
          / {{countObj.totalPayGroups}}
        </div>
      </div>
      <div class="alignPaygrp">
        <span>Total Employees</span>
        <br />
        <div class="paygrps-info">
          <b>{{countObj.totalEmployeesSelected}}</b>
          / {{countObj.totalEmployees}}
        </div>
      </div>
      <div class="alignPaygrp">
        <span>Eligible Employees</span>
        <br />
        <div class="paygrps-info">
          <b>{{countObj.eligibleEmployeesSelected}}</b>
          / {{countObj.totalEmployees}}
        </div>
      </div>
    </div>
    <div class="d-payroll__group">
      <div class="d-heading2 d-marginBottom d-flexbox"></div>
    </div>
    <div class="uploadMethoRadio">
      <tl-radio
        name="uploadMethod"
        label="Bulk Upload"
        id="bulkUpload"
        value="bulkUpload"
        v-model="uploadMethod"
      />

      <tl-radio
        name="uploadMethod"
        label="Manual"
        id="manualUpload"
        value="manualUpload"
        v-model="uploadMethod"
      />
    </div>

    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <div v-if="uploadMethod == 'bulkUpload'">
      <div class="download-btn">
        <!-- <download-button
          onclick="location.href='https://dev-opn-test1.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/Template-+Exit+employee.xlsx'"
        ></download-button> -->
        <download-button class="margin-l-m margin-t-m" @downloadTemplate="downloadTemplate()"></download-button>
      </div>
      <div class="margintop-20">
        <!-- <upload-file @uploadTemplate="onUploadTemplate($event)" /> -->
        <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" />
      </div>
    </div>

    <div v-else>
        <div class="row">
          <div class="col-3 padding">
            <search-dropdown
              v-if="!showEmpDetails"
              label="Select Employee"
              :employeeData="employeeData"
              @clear="(val) =>{clearEmployee()}"
              @getList="searchDataList($event)"
              @empselected="(emp)=>selectedEmp(emp)"
            />
          
            <selected-employee-card
              v-if="showEmpDetails"
              :empName="employeeCard.name"
              :empId="employeeCard.code"
              :empMail="employeeCard.email_id"
              @click="close"
            >
            </selected-employee-card>
          </div>  
      </div>
      <div class="fourColumnGrid">
        <div class="selectdiv label">
          <span class="input-label">Resignation Date *</span>
          <date-picker
            @datevalue="updateDateValues"
            name="Resignation date"
            v-model="employeeObject.resignation_date"
            :dates-disabled="{from: new Date() , to: new Date(employeeCard.date_of_joining) }"
            v-validate="{required: true}"
            :classname="errors.has('Resignation date')"
            :errormsg="errors.first('Resignation date')"
          />
        </div>

        <div class="selectdiv label">
          <span class="input-label">Last Working Day *</span>
          <date-picker
            @datevalue="(val)=>employeeObject.last_working_date=val"
            name="Last Working Day"
            v-model="employeeObject.last_working_date"
            :disable="employeeObject.resignation_date==''"
            :dates-disabled="{to: resignation_date}"
            v-validate="{required: true}"
            :classname="errors.has('Last Working Day')"
            :errormsg="errors.first('Last Working Day')"
          />
        </div>
      </div>
      <div class="customGrid">
        <div class="exit-reason">
          <tl-select
            label="Reason For Exit *"
            labelText="name"
            name="Reason"
            v-model="employeeObject.reason"
            :options="exitReasonsArray"
            @change="exitReasonChanged($event)"
            v-validate="'required'"
            :classname="errors.has('Reason')"
            :errormsg="errors.first('Reason')"
          />
        </div>
        <div class="margin-b-l">
          <div class>
            <txt
              type="textarea"
              label="Remarks *"
              v-model="employeeObject.remarks"
              name="Remarks"
              v-validate="'required'"
              :classname="errors.has('Remarks')"
              :errormsg="errors.first('Remarks')"
            ></txt>
          </div>
        </div>
      </div>
      <div v-if="addedEmployeeForExitsList.length">
        <div class="selectedComp">
          <div v-for="(data,index) in addedEmployeeForExitsList" :key="index">
            <div class="rect">
              <button>
                <span>
                  {{ data.employeeName }}
                  <img src="@/assets/group-6.svg" @click="removeTag(index)" />
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <btn text="Add Employee" type="secondary" @click="addEmployee()" />
    </div>

    <div class="lock-list">
      <tl-checkbox label="Lock Exits List" @change="(bool)=>locklist(bool)"></tl-checkbox>
    </div>
    <footer>
      <bottom-action-container>
        <btn-skip @navClicked="skip"></btn-skip>
        <template slot="end">
          <btn-grp class="form-button">
            <btn text="Cancel" type="secondary" @click="cancel" />
            <btn text="Next" :disabled="!isLockingExits" type="primary" @click="save" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </footer>

    <pop-up-message
      v-if="showBulkUploadSuccessMsg"
      :message="`${popupMessage}`"
      btnText="Back"
      @back="back"
    ></pop-up-message>
    <pop-up-message
      v-if="showErrorPopup"
      message=""
      popupType="Warning"
      :popupHeaderMessage="'UPLOAD FAILED!!!'"

    >
        <template v-slot:bottomContent>
       
    <div class="margintop-32 custom-container">
    <a :href="logSheetUrl"
      @click="downloadItem(logSheetUrl)"
    ><img src="@/assets/download.svg"   class="img" @click="downloadItem(logSheetUrl)" /> <span class="text">Error Log Sheet</span></a>
        </div>

        <div class="popup-btn-group margintop-32 marginright">

          <button class="btn-popup" type="button" @click="back()">"Back To Employee Dashboard"</button>

         <!-- <button class="btn-popup" type="button" @click="uploadFile2($event)">Proceed</button>
              -->  </div>
      </template>
    </pop-up-message>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import selectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
import { api_variables } from "@/apis/variables.js";
export default {
  name: "Exit",
  components: { SearchDropdown, selectedEmployeeCard },
  data() {
    return {
      bulkUploadRequestObj : null,
      logSheetUrl : null,
      bulkUploadUrl: api_variables.SERVICE_EMP_EXITS_UPLOAD_TEMPLATE,
      uploadMethod: "manualUpload",
      empCN: "",
      empId: "",
      isLockingExits: false,
      reason: "",
      remarks: "",
      esiRemarks: "",
      auto_suggestions: false,
      showEmpDetails: false,
      filterEmpData: [],
      employeeData: [],
      exitsCount: 0,
      countObj: {
        payGroupsSelected: 0,
        totalEmployeesSelected: 0,
        eligibleEmployeesSelected: 0,
        totalResignees: 0,
        totalPayGroups: 0,
        totalEmployees: 0,
        totalEligibleEmployees: 0
      },

      addedEmployeeForExitsList: [],
      employeeObject: {
        empId: null,
        reason: null,
        resignation_date: "",
        last_working_date: "",
        remarks: null,
        employeeName: null
      },
      isEmployeeSelected: false,
      employeeCard: {
        name: null,
        code: null,
        email_id: null,
        photo_url: null,
        date_of_joining: null
      },
      popupMessage: "",
      showBulkUploadSuccessMsg: false,
      showErrorPopup: false,
      exitReasonsArray: [
        {
          id: "Absconding",
          name: "Absconding"
        },
        {
          id: "Death",
          name: "Death"
        },
        {
          id: "Termination",
          name: "Termination"
        },
        {
          id: "Resigned",
          name: "Resigned"
        },
        // {
        //   id: "fired",
        //   name: "Fired"
        // },
        {
          id: "Retirement/ Super Annutation",
          name: "Retirement/ Super Annutation"
        }
      ],
      errmsg: "",
      toast: false,
      resignation_date: "",
      searchText: ""
    };
  },
  activated() {
    this.uploadMethod = "manualUpload";
    this.$validator.reset();
    this.refresh();
    this.fetchAll();
    this.fetchPaygroupsUpdatedData();
    this.setData();
  },
  mounted() {
    this.fetchAll();
    this.fetchPaygroupsUpdatedData();
    this.setData();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      employeesExitsData: state => state.payroll.exits.exits,
      employeesJoiningsData: state => state.payroll.joinings.joinings,
      selectedPayGroupsData: state => state.payroll.paygroups.data,
      payGroupsData: state => state.payroll.paygroups.payGroups,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  methods: {
    ...mapActions({
      act_fetchAll: "payroll/exits/fetchExits",
      act_create: "payroll/exits/create",
      act_upload_template:
        "dashboard/payroll/utilities/addexitemployees/uploadTemplate",
      act_fetchLegalEntityNonExitsEmployeeSearchList:
        "dashboard/payroll/utilities/addexitemployees/fetchLegalEntityNonExitsEmployeeSearchList",
      act_fetch_paygroups_updated_data: "payroll/paygroups/fetchAll",
      act_download_template: "dashboard/payroll/utilities/addexitemployees/downloadTemplate"
    }),

    async downloadTemplate() {
      try {
      let data={
         le_id : this.le_id,
        }
        let res = await this.act_download_template(data);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Function to fetch the Paygroups data */
    async fetchPaygroupsUpdatedData() {
      try {
        let res = await this.act_fetch_paygroups_updated_data({
          le_id: this.le_id,
          processing_payroll_month: this.getSelectedMonthEnumByName(
            this.payrollMonth
          ),
          financial_year: this.payrollYear
        });
        if (res.status == 200 || res.status == 201) {
          this.setData();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
  /** Function to fetch the month enum by name */
    getSelectedMonthEnumByName(selectedMonth) {
      try {
        let selectedMonthEnum = "";
        switch (selectedMonth) {
          case "January":
            selectedMonthEnum = "jan";
            break;
          case "February":
            selectedMonthEnum = "feb";
            break;
          case "March":
            selectedMonthEnum = "mar";
            break;
          case "April":
            selectedMonthEnum = "apr";
            break;
          case "May":
            selectedMonthEnum = "may";
            break;
          case "June":
            selectedMonthEnum = "jun";
            break;
          case "July":
            selectedMonthEnum = "jul";
            break;
          case "August":
            selectedMonthEnum = "aug";
            break;
          case "September":
            selectedMonthEnum = "sep";
            break;
          case "October":
            selectedMonthEnum = "oct";
            break;
          case "November":
            selectedMonthEnum = "nov";
            break;
          case "December":
            selectedMonthEnum = "dec"; // PL-2264
            break;

          default:
            break;
        }
        return selectedMonthEnum; // Enum type - values :  ['jan', 'feb','mar', 'apr','may', 'jun','jul', 'aug','sep', 'oct','nov', 'dec']
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On 'Skip' button click */
    skip() {
      try {
        this.refresh();
        this.$router.push({
          path: `/payroll/run/${
            this.$route.params.entity_index
              ? this.$route.params.entity_index
              : 0
          }/lopsandrlops`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On search */
    searchDataList(val) {
      this.getEmployeesByName(val);
    },
    /** Function to fetch the list of employees by name from the server */
    async getEmployeesByName(val) {
      try {
        let obj = {
          key: val,
          le_id: this.le_id
        };
        let res = await this.act_fetchLegalEntityNonExitsEmployeeSearchList(
          obj
        );
        this.employeeData = [];
        if (res.data.payload) {
          let payloadArray = res.data.payload ? res.data.payload : [];
          this.employeeData = payloadArray;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
  /** On date picker change */
    updateDateValues(value, dateObj) {
      try {
        this.employeeObject.resignation_date = value;
        this.employeeObject.last_working_date = "";
        this.resignation_date = dateObj;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** To fetch the exit employee list */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.le_id);
        this.exitsCount = 0;
        for (var i = 0; i < res.data.payload.length; i++) {
          this.exitsCount = this.exitsCount + 1;
        }
        if (res.message != null) {
          throw Error(res.message);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** On employee selection from the search bar */
    selectedEmp(emp) {
      try {
        this.empCN = emp.first_name;
        this.empId = emp.code;
        
        this.employeeCard = {
          name: emp.first_name,
          code: emp.code,
          email_id: emp.email_id,
          photo_url: emp.photo_url ? emp.photo_url : null,
          date_of_joining: emp.EmployeeOfficial
            ? emp.EmployeeOfficial.date_of_joining
            : null /** PL_1673 */
        };

        this.employeeObject.employeeName = emp.first_name;
        this.employeeObject.empId = emp.id;
        this.isEmployeeSelected = true;
        this.showEmpDetails = true;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** To clear the selected employee data */
    clearEmployee() {
      this.empName = null;
      this.empId = null;
    },

    /** Function to set the counts of different elements in UI */
    setData() {
      try {
        let payGroupsData = this.payGroupsData[this.le_id];
        let selectedPayGroupsData = this.selectedPayGroupsData[this.le_id];

        if (payGroupsData) {
          this.countObj.totalPayGroups = payGroupsData.length;

          let totalEmployees = 0;
          let totalEligibleEmployees = 0;

          payGroupsData.forEach(item => {
            totalEmployees =
              totalEmployees + (item.totalEmployess ? item.totalEmployess : 0);
            totalEligibleEmployees =
              totalEligibleEmployees +
              (item.eligibleEmployees ? item.eligibleEmployees : 0);
          });

          this.countObj.totalEmployees = totalEmployees;
          this.countObj.totalEligibleEmployees = totalEligibleEmployees;
        }

        if (selectedPayGroupsData) {
          this.countObj.payGroupsSelected = selectedPayGroupsData.length;

          let totalEmployeesSelected = 0;
          let eligibleEmployeesSelected = 0;
          let totalResignees = 0;

          selectedPayGroupsData.forEach(item => {
            totalEmployeesSelected =
              totalEmployeesSelected +
              (item.totalEmployess ? item.totalEmployess : 0);
            eligibleEmployeesSelected =
              eligibleEmployeesSelected +
              (item.eligibleEmployees ? item.eligibleEmployees : 0);
            totalResignees =
              totalResignees + (item.resignees ? item.resignees : 0);
          });

          this.countObj.totalResignees = totalEmployeesSelected;
          this.countObj.totalEmployeesSelected = totalEmployeesSelected;
          this.countObj.eligibleEmployeesSelected = eligibleEmployeesSelected;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** To remove an employee from the added list in UI */
    removeTag(index) {
      try {
        this.addedEmployeeForExitsList.splice(index, 1);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On exit reason drop down change */
    exitReasonChanged(event) {
      try {
        this.employeeObject.reason = event ? event : null;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
  /** Function to add an employee for exit in UI */
    addEmployee() {
      try {
        this.$validator.validateAll().then(result => {
          if (result) {
            if (this.employeeObject.empId) {
              let index = this.addedEmployeeForExitsList.findIndex(
                item => item.empId === this.employeeObject.empId
              );
              if (index > -1) {
                this.toast = true;
                this.errmsg =
                  "This employee is already selected. Please select another employee";
                return;
              } else {
                this.toast = false;
                this.errmsg = "";
              }
            } else {
              this.toast = true;
              this.errmsg = "Please select an employee";
              return;
            }

            this.addedEmployeeForExitsList.push(this.employeeObject);

            this.employeeObject = {
              empId: null,
              reason: null,
              resignation_date: "",
              last_working_date: "",
              remarks: "",
              employeeName: null
            };
            this.isEmployeeSelected = false;
            this.showEmpDetails = false;
            this.addedEmployeeForExitsList = [
              ...this.addedEmployeeForExitsList
            ];
          }
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Navigation on 'cancel' button click */
    cancel() {
      try {
        this.$router.push({
          path: `/payroll/run/${
            this.$route.params.entity_index
              ? this.$route.params.entity_index
              : 0
          }/joinings`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to validate the form data */
    save() {
      try {
        if (this.addedEmployeeForExitsList.length) {
          this.toast = false;
          this.errmsg = "";
          this.performAction();
        } else {
          this.refresh();
          this.$router.push({
            path: `/payroll/run/${
              this.$route.params.entity_index
                ? this.$route.params.entity_index
                : 0
            }/lopsandrlops`
          });
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
     /** To lock/unlock the 'Next' button */
    locklist(ee) {
      try {
        this.isLockingExits = ee;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to save form data to server */
    async performAction() {
      try {
        let finalArr = [];

        if (this.addedEmployeeForExitsList.length > 0) {
          this.addedEmployeeForExitsList.forEach(item => {
            let obj = {
              le_id: this.le_id,
              employee_id: item.empId,
              initiation_date: item.resignation_date,
              last_working_date: item.last_working_date,
              reason_for_exit: item.reason ? item.reason.id : null,
              remarks: item.remarks
            };
            finalArr.push(obj);
          });
          let requestObj = {
            data: finalArr
          };
          try {
            this.$root._data.isSaving = true;
            let res = await this.act_create(requestObj);
            setTimeout(() => {
              if (res.status == 200 || res.status == 201) {
                this.refresh();
                this.$router.push({
                  path: `/payroll/run/${
                    this.$route.params.entity_index
                      ? this.$route.params.entity_index
                      : 0
                  }/lopsandrlops`
                });
              }
              this.$root._data.isSaving = false;
            }, 500);
          } catch (error) {
            this.$root._data.isSaving = false;
            this.toast = true;
            this.errmsg = error;
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to refresh the form data */
    refresh() {
      try {
        this.empCN = "";
        this.reason = "";
        this.remarks = "";
        this.esiRemarks = "";
        this.searchText = "";

        this.employeeObject = {
          empId: null,
          reason: null,
          resignation_date: "",
          last_working_date: "",
          remarks: null,
          employeeName: null
        };
        this.isEmployeeSelected = false;
        this.addedEmployeeForExitsList = [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    
    close () {
      this.showEmpDetails = false;
      this.employeeObject = {
          empId: null,
          reason: null,
          resignation_date: "",
          last_working_date: "",
          remarks: null,
          employeeName: null
      };
    },

    /* function to get response after uploading in bulk */
    async onUploadTemplate(response) {
      try {
        let res = response.response;
        if(response.data.message == 'Failed'){         
          this.popupMessage = response.message ? response.message : "Failed";
          this.showErrorPopup = true;
          this.logSheetUrl = response.data.payload[0]              
        }
        else{
          this.popupMessage = response.message ? response.message : "";
          this.showBulkUploadSuccessMsg = true;
        }
        // else {
        //   this.toast = true;
        //   this.errmsg = res.data.message;
        // }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
    /***** BULK UPLOADS *****/
    /*
    async onUploadTemplate(event) {
      let formData = new FormData();
      formData.append("file", event);
      formData.append("le_id", this.le_id);

      try {
        let res = await this.act_upload_template(formData);
        if (res.status == 200 || res.status == 201) {
          this.popupMessage = res.message ? res.message : "";
          this.showBulkUploadSuccessMsg = true;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    */

    back() {
      try {
        this.showBulkUploadSuccessMsg = false;
        this.showErrorPopup = false;
        // Start PL_3388 changes by Bhushan
        this.$router.go(1); // Add here
        //this.$router.push({
          //path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`  
        //});
        // End PL_PL_3388
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section
.paygrpsDiv {
  display: flex;
  cursor: pointer;
  padding: 40px 0px;
  span {
    color: #646464;
    font-size: 16px;
  }
  > :nth-child(n) {
    margin-right: 64px;
  }
  > :last-child {
    margin-right: 0px;
  }
}

.paygrp {
  background: #fbfbfb;
  width: 220px;
  height: 85px;
  border-radius: 2px;
  border: solid 1px #37c6c0;
  padding: 20px;
  text-align: center;
}
.alignPaygrp {
  padding: 20px;
  text-align: center;
}
.d-marginBottom {
  margin-bottom: 7px;
}
.line {
  border-bottom: 1px solid #c8c8c8;
  width: 100%;
  margin-bottom: 20px;
}

.uploadMethoRadio {
  margin-top: 30px;
  margin-bottom: 2%;
  display: flex;
}

.label {
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 8px;
  color: #6e6e6e;
}
.download-btn {
  margin-top: 2%;
}

.payslips {
  width: 37%;
}
.custom-select {
  width: 100%;
  height: 35px;
  max-width: 323px;
}
.aligntext {
  text-align: center;
}
.lock-list {
  margin-top: 2%;
  display: flex;
  span {
    margin-top: 2px;
  }
}
.fourColumnGrid {
  display: grid;
  grid-template-columns: 0.21fr 0.2fr 0.2fr;
  grid-gap: 10px;
  margin-bottom: 2%;
  margin-top: 1%;
}

.customGrid {
  display: grid;
  grid-template-columns: 0.21fr 0.4fr 0.2fr;
  grid-gap: 10px;
  margin-bottom: 2%;
  margin-top: 1%;

  .exit-reason {
    min-width: 300px;
  }
}

.twoColumnGrid {
  width: 52%;
  margin-top: 20px;
}
.third-row {
  margin-top: -10%;
}
.img-part {
  img {
    width: 100%;
  }
}

.selectedComp {
  display: flex;
  flex-wrap: wrap;
  width: 50%;
  min-height: 50px;
  border-radius: 8px;
  // border: solid 1px #dadada;
  background-color: #ffffff;
  margin-bottom: 1.1%;
}
.card {
  display: flex;
  width: 31%;
  margin-right: 12px;
  height: 110px;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
  margin-bottom: 20px;
}

.image {
  .alignImage {
    width: 80px;
    height: 80px;
    margin: 15px 0 0 15px;
  }
}

.emp-details {
  padding: 25px 0 0 10px;
  color: #535353;
}

.rect {
  padding: 5px 10px 5px 10px;
  margin: 2px;
  height: 30px;
  border-radius: 15px;
  background-color: #c7efef;
  text-align: center;
}

.selectdiv {
  select {
    width: 100%;
    border-radius: 4px;
    outline: 0;
    font-size: 14px;
    //color: #9f9da2;
    border: 1px solid #dadada;
    padding: 0 10px;

    &.errorr {
      border: 1px solid #e01717;
    }
    // &.errorMessage {
    //   color: #e01717;
    // }
  }
  span {
    //font-size: 12px;
    //margin-left: 3px;
    // color: #9f9da2;
  }
}

.padding{
  padding: 10px 0;
}
.paygrps-info {
  color: #646464;
  cursor: pointer;
  text-align: center;
  margin-top: 5px;
  b {
    font-size: 24px;
    font-weight: 500;
  }
}
</style>
